import en from "./en";
import it from "./it";
import {initLocale} from "@kopjra/uikit";

export const translations = {
    en,
    it,
};
export const defaultLocale = initLocale(translations, "it");
